/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import * as React from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import invitebird from '../../../assets/need-invite-bird.png';
import { TeamsInitializationStatus } from '../../../hosts/IHost';
import { EntryPoint, LogCategory, ScenarioName, StatusName, StepName } from '../../../logger';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { ChooseTemplate } from '../../../views/containers/ChooseTemplate';
import { ErrorPage } from '../../../views/containers/ErrorPage/ErrorPage';
import { MobileNavigationBar } from '../../MobileNavigationBar/MobileNavigationBar';

export interface CreateRequestMenuProps {
    showNaviBar?: boolean;
    isNewChat?: boolean;
}

export const MobileCreateRequestMenuV2: React.FC<CreateRequestMenuProps> = (
    props: CreateRequestMenuProps
): JSX.Element => {
    const { showNaviBar, isNewChat } = props;
    const isPersonalApp = showNaviBar;
    const entryPoint = isPersonalApp ? EntryPoint.PersonalApp : EntryPoint.ComposeExtension;

    const history = useHistory();

    useEffect((): any => {
        const logger = getAppHost().getLogger();

        getAppHost().setNavBarMenu([], null);

        logger.logTraceInfo(LogCategory.AppBoot, 'Notifying Teams for init success in mobile create request menu');
        getAppHost().notifyTeamsInitialization(TeamsInitializationStatus.Success);

        // mark create request menu v2 scenario.
        logger.markScenario(ScenarioName.CreateRequestMenu, StepName.MobileCreateRequestMenuV2Rendered, StatusName.NA);

        if (entryPoint === EntryPoint.ComposeExtension) {
            logger.markScenario(ScenarioName.AppBoot, StepName.AppBootMobileCreateRequestMenuV2Rendered, StatusName.NA);
            logger.stopScenario(ScenarioName.AppBoot);
        }
        return (): void => {
            // stop create request menu scenario
            logger.stopScenario(ScenarioName.CreateRequestMenu);
        };
    }, [entryPoint]);

    if (isNewChat) {
        return <ErrorPage message={getAppHost().getLocale().strings.no_chat_message} image={invitebird} />;
    }

    return (
        <>
            {showNaviBar && <MobileNavigationBar onSelected={history.goBack} />}
            <ChooseTemplate entryPoint={entryPoint} tiled />
        </>
    );
};
